import BannerResource from '@structure/Resources/Banner';
import { mapState } from 'vuex';
import { serviceUrl } from '@/support';

export default {
  props: {
    resource: {
      required: true,
      type: BannerResource,
    },
  },

  mounted() {
    this.$nextTick(this.updateSource.bind(this));
  },

  watch: {
    // This watches the pathname. When a change is detected, it wipes the current
    // banner source used by the iframe or img tag and queues a proper re-evaluation
    // of the source value on the next tick in Vue's render cycle.
    //
    // This prevents a flickering/resizing issue when swapping between banners.
    pathname() {
      this.source = '';

      this.$nextTick(this.updateSource.bind(this));
    },

    time() {
      this.$nextTick(this.updateSource.bind(this));
    },
  },

  data() {
    return {
      source: '',
      cacheToken: Math.random().toString(36).slice(2),
    };
  },

  computed: {
    ...mapState(['time']),

    pathname() {
      return this.resource.path();
    },
  },

  methods: {
    updateSource() {
      let url;

      if (this.resource.isCompressed()) {
        url = serviceUrl(['api/unpack']);
        url.searchParams.append('path', this.resource.path());
      } else {
        url = serviceUrl(['api/content', this.resource.path()]);
      }

      url.searchParams.append('c', this.cacheToken);

      if (this.resource.config().timetravel()) {
        url.searchParams.append('date', this.time.sinceEpoch);
        url.searchParams.append('tz', this.time.zone);
      }

      this.source = url.toString();
    },
  },
};
